function handleYouTube() {
    // Ladda YouTube IFrame API
    var youtubePlayers = document.querySelectorAll('.video-player-wrapper[data-video-type="youtube"]')
    if (youtubePlayers.length === 0) return

    if (typeof YT === 'undefined' || typeof YT.Player === 'undefined') {
        var tag = document.createElement('script')
        tag.src = 'https://www.youtube.com/iframe_api'
        var firstScriptTag = document.getElementsByTagName('script')[0]
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
    }

    // Initieras när YouTube API är klart
    window.onYouTubeIframeAPIReady = function () {
        var youtubePlayers = document.querySelectorAll('.video-player-wrapper[data-video-type="youtube"]')

        youtubePlayers.forEach(function (playerWrapper) {
            var videoId = playerWrapper.getAttribute('data-video-id')
            var autoplay = parseInt(playerWrapper.getAttribute('data-video-autoplay'), 10)
            var controls = parseInt(playerWrapper.getAttribute('data-video-controls'), 10)

            // Skapa en div för YouTube-spelaren
            var playerDiv = document.createElement('div')
            playerWrapper.querySelector('.video-player').appendChild(playerDiv)

            // Initiera YouTube-spelaren
            var ytPlayer = new YT.Player(playerDiv, {
                height: '360',
                width: '640',
                videoId: videoId,
                playerVars: {
                    autoplay: 0, // Autoplay hanteras av IntersectionObserver
                    controls: controls,
                    mute: autoplay,
                    loop: autoplay,
                    playlist: videoId,
                    modestbranding: 1,
                    playsinline: 1,
                    fs: 0,
                    cc_load_policy: 0,
                    iv_load_policy: 3,
                    autohide: autoplay,
                },
                events: {
                    onReady: function (event) {
                        // Använd IntersectionObserver för att starta videon när den är i viewport
                        if (autoplay) {
                            var observer = new IntersectionObserver(
                                function (entries, obs) {
                                    entries.forEach(function (entry) {
                                        if (entry.isIntersecting) {
                                            event.target.playVideo() // Spela video
                                            obs.unobserve(entry.target) // Koppla bort observern
                                        }
                                    })
                                },
                                { threshold: 0.5 } // Justera tröskelvärdet efter behov
                            )

                            observer.observe(playerWrapper)
                            const playPause = playerWrapper.querySelector('.play-pause')

                            if (playPause) {
                                playPause.addEventListener('click', function () {
                                    if (playPause.classList.contains('remove-play-pause')) {
                                        playPause.remove()
                                        event.target.seekTo(0)
                                        event.target.unMute()
                                        event.target.playVideo()
                                        return
                                    }

                                    if (playPause.classList.contains('paused')) {
                                        playPause.classList.remove('paused')
                                        event.target.playVideo()
                                    } else {
                                        playPause.classList.add('paused')
                                        event.target.pauseVideo()
                                    }
                                })
                            }
                        }
                    },
                },
            })
        })
    }
}

function handleHTML5() {
    // Ladda HTML5-videospelaren
    var html5Players = document.querySelectorAll('.video-player-wrapper[data-video-type="html5"]')
    if (html5Players.length === 0) return

    html5Players.forEach(function (playerWrapper) {
        const video = playerWrapper.querySelector('video')

        const playPause = playerWrapper.querySelector('.play-pause')
        if (playPause) {
            playPause.addEventListener('click', function (event) {
                if (playPause.classList.contains('remove-play-pause')) {
                    playPause.remove()
                    video.currentTime = 0
                    video.muted = false
                    video.play()
                    return
                }

                if (playPause.classList.contains('paused')) {
                    playPause.classList.remove('paused')
                    video.play()
                } else {
                    playPause.classList.add('paused')
                    video.pause()
                }
            })
        }
    })
}

function handleVimeo() {
    var vimeoPlayerWrappers = document.querySelectorAll('.video-player-wrapper[data-video-type="vimeo"]')
    if (vimeoPlayerWrappers.length === 0) return

    var tag = document.createElement('script')
    tag.src = 'https://player.vimeo.com/api/player.js'
    var firstScriptTag = document.getElementsByTagName('script')[0]
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)

    tag.onload = function () {
        vimeoPlayerWrappers.forEach(function (playerWrapper) {
            var videoId = playerWrapper.getAttribute('data-video-id')
            var autoplay = parseInt(playerWrapper.getAttribute('data-video-autoplay'), 10)
            var controls = parseInt(playerWrapper.getAttribute('data-video-controls'), 10)
            const playerDiv = playerWrapper.querySelector('.video-player')

            const vimeoPlayer = new Vimeo.Player(playerDiv, {
                id: videoId,
                autoplay: 0,
                controls: controls,
                muted: autoplay,
                loop: autoplay,
            })

            if (autoplay) {
                var observer = new IntersectionObserver(
                    function (entries, obs) {
                        entries.forEach(function (entry) {
                            if (entry.isIntersecting) {
                                vimeoPlayer.play()
                                obs.unobserve(entry.target)
                            }
                        })
                    },
                    { threshold: 0.5 }
                )
                observer.observe(playerWrapper)
            }

            vimeoPlayer.on('play', function () {
                playerWrapper.classList.add('video-activated')
            })

            vimeoPlayer.on('pause', function () {
                playerWrapper.classList.remove('video-activated')
            })

            const playPause = playerWrapper.querySelector('.play-pause')
            if (playPause) {
                playPause.addEventListener('click', function () {
                    vimeoPlayer.getPaused().then(function (paused) {
                        if (playPause.classList.contains('remove-play-pause')) {
                            playPause.remove()
                            vimeoPlayer.setCurrentTime(0)
                            vimeoPlayer.setVolume(1)
                            vimeoPlayer.play()
                            return
                        }
                        if (paused) {
                            playPause.classList.remove('paused')
                            vimeoPlayer.play()
                        } else {
                            playPause.classList.add('paused')
                            vimeoPlayer.pause()
                        }
                    })
                })
            }
        })
    }
}

document.addEventListener('DOMContentLoaded', function () {
    handleYouTube()
    handleHTML5()
    handleVimeo()
})
